const getters = {
  token: state => state.user.token,
  userName: state => state.user.userName,
  userId: state => state.user.userId,
  device: state => state.app.device,
  badgeVal: state => state.badgeVal,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js